'use strict';

/**
 * Simple helper method to update a "puck" element to match a targetEl's left-position and width.
 */
export function updatePuck(targetEl, cancelTransitions) {
    let puckContainer = targetEl ? (targetEl.closest('[data-puck-component="container"]') || targetEl.parentNode) : null,
        puckEl = puckContainer ? puckContainer.querySelector('[data-puck-component="puck"]') : null;

    if (puckEl) {
        let puckContainerPosX = puckContainer.getBoundingClientRect().left,
            targetElRect = targetEl.getBoundingClientRect(),
            targetElComputed = window.getComputedStyle(targetEl),
            targetElPaddingLeft = parseFloat(targetElComputed['padding-left']),
            targetElPaddingRight = parseFloat(targetElComputed['padding-right']),
            newPosX = Math.abs(puckContainerPosX - targetElRect.left - targetElPaddingLeft);

        //Disable animations when `cancelTransitions` is present so that the puck
        //can display the correct styles on module or page load.
        if (cancelTransitions) {
            puckEl.classList.add('set--cancel-transitions');
        } else {
            puckEl.classList.remove('set--cancel-transitions');
        }

        puckEl.style.transform = `translateX(${newPosX}px)`;
        puckEl.style.width = `${targetElRect.width - targetElPaddingLeft - targetElPaddingRight}px`;
    }
}
